function NfpNetworkModule(ui, enabled) {
    this.ui = ui;
    this.network = dazeth.chainId;
    this.location = "hidden";
    this.name = "network";
    this.label = "Network";
    this.inline = ``;
    this.blocks = [];
}

NfpNetworkModule.prototype.Init = async function () {
    this.blocks = document.querySelectorAll(`module[data-load="network"]`);
}

NfpNetworkModule.prototype.initListeners = function () {
    $(document).on('dazEthError', function (e, type, tokenID, data) {
        switch (type) {
            case 'wrong-network':
                this.ui.modal.Critical('Wallet Network Error', `It looks like your wallet is configured for the wrong network. Please change to the ${window.dazeth.network} network to continue.`, [{
                    text: "Change to Ethereum Network",
                    callback: () => dazeth.ChangeToChain()
                }])
                break;
            case 'chain-changed':
                this.ui.chainChanged(tokenID);
                this.Reset();
                break;
        }
    });
}

NfpNetworkModule.prototype.Display = async function () {
    // Nothing to display
}

NfpNetworkModule.prototype.IsNftBlocked = function () {
    return false;
}

NfpNetworkModule.prototype.Reset = async function () {
    let div = document.createElement("div");
    let sel = document.createElement("select");

    for (let networkID in dazeth.chains) {
        const network = dazeth.chains[networkID];
        const opt = document.createElement("option");
        opt.value = networkID;
        opt.text = network.name;
        opt.selected = networkID === dazeth.chainId;
        sel.appendChild(opt);
    }
    sel.addEventListener("change",  async () => {
        if (sel.selectedOptions[0].value === dazeth.chainId) {
            return;
        }

        return dazeth.ChangeToChain(sel.selectedOptions[0].value).then(() => {}, async (switchError) => {
            const selected = sel.selectedOptions[0].value;


            if (switchError.data && switchError.data.originalError) {
                switchError = switchError.data.originalError;
            }

            // This error code indicates that the chain has not been added to MetaMask.
            if (switchError.code === 4902) {
                try {
                    await dazeth.AddNetwork(selected);
                    return;
                } catch (addError) {
                    this.ui.modal.Error('Wallet Network Error', 'Could not add network')
                }
            }
            for (const i in sel.options) {
                if (sel.options[i].value !== dazeth.chainId) {
                    continue;
                }
                sel.options[i].selected = true;
                break;
            }
        });
    })
    div.append("Network: ");
    div.appendChild(sel);

    this.blocks.forEach((e, i) => {
        if (e.classList.contains('initialized')) {
            return;
        }
        e.appendChild(div);
        e.classList.add('initialized');
    })
}
